module.exports = __webpack_public_path__ + "img/24-7-monitoring-icon.ae3d3f62.png";